import React from "react";
import { motion } from "framer-motion";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ServicesCards from "../Components/ServicesCards";
import Button from "../Components/Button";
import SEO from "../Components/SEO";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faPhone } from "@fortawesome/free-solid-svg-icons";

const fadeInUp = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

const servicesSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "serviceType": "Electroplating and Metal Finishing",
  "provider": {
    "@type": "LocalBusiness",
    "name": "ElectroPlating Lebanon"
  },
  "areaServed": {
    "@type": "Country",
    "name": "Lebanon"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Electroplating Services",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Chrome Plating",
          "description": "Professional chrome plating for automotive, industrial, and decorative applications"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Gold Plating",
          "description": "High-quality gold plating for jewelry, electronics, and luxury items"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Silver Plating",
          "description": "Expert silver plating services for various applications"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Nickel Plating",
          "description": "Durable nickel plating for corrosion resistance and aesthetics"
        }
      }
    ]
  }
};

const ServicesPage = () => {
  return (
    <main>
      <SEO
        title="Our Services"
        description="Explore ElectroPlating Lebanon's comprehensive metal finishing services including chrome plating, gold plating, silver plating, nickel plating, and custom electroplating solutions."
        keywords="electroplating services, chrome plating Lebanon, gold plating, silver plating, nickel plating, metal finishing services, custom plating"
        canonicalUrl="/services"
        structuredData={servicesSchema}
      />

      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.1 }}
        variants={fadeInUp}
      >
        <ServicesCards />
      </motion.div>

      {/* CTA Section */}
      <motion.section
        className="services-cta-section"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
        variants={fadeInUp}
      >
        <Container>
          <Row className="align-items-center">
            <Col lg={8}>
              <h2 className="services-cta-title">Need a Custom Solution?</h2>
              <p className="services-cta-text">
                Our team of experts is ready to discuss your specific requirements and
                develop a tailored finishing solution for your project.
              </p>
            </Col>
            <Col lg={4} className="services-cta-buttons">
              <Button to="/contact" variant="primary" size="lg">
                Get a Quote <FontAwesomeIcon icon={faArrowRight} className="ms-2" />
              </Button>
              <a href="tel:+96103518323" className="services-cta-phone">
                <FontAwesomeIcon icon={faPhone} className="me-2" />
                +961 03 518 323
              </a>
            </Col>
          </Row>
        </Container>
      </motion.section>
    </main>
  );
};

export default ServicesPage;
